import { Component, OnInit, ViewChild } from '@angular/core';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { InvDettransfer } from '../invinterfaces/invdettransfer';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { InvEnctransfer } from '../invinterfaces/invenctransfer';
import { Usuario } from 'src/app/usuario';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvenctransferrecibidoService } from "../invservicios/invenctransferrecibido.service";
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { InvbusquedaService } from '../invservicios/invbusqueda.service';
import { DatePipe } from '@angular/common';
import { ErroresBaseDatosService } from '../../servicios/errores-base-datos.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-invenctransferrecibido',
  templateUrl: './invenctransferrecibido.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InvenctransferrecibidoComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  hmpConfiguracion: any[];
  indicador: any;

  barraBotones2: boolean;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  botonFactura: boolean;
  botonAnular: boolean;
  botonXML: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;
  botonAutorizar: boolean;
  barraTransferencia: boolean;
  //horacam;
  botonTransferencia;
  chkguiaremision: boolean;

  index: number;

  dettransferSelected: InvDettransfer;
  // trnvariostrfSelected: InvTrnvariostrf;

  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  consulta: string;
  tabla: string;
  where: string;
  opcionbusqueda: string;
  control = 0;
  // dialogs
  displayDialogBusqueda: boolean;
  displayDialogBusquedaFast: boolean;
  displayDialogAutorizacion: boolean;
  displayDialogSeriales: boolean;
  displayDialogReportes: boolean;
  displayAcciones: boolean;
  groupCodProv: boolean;
  groupDatosPorNumAdic: boolean;
  // autorizacion
  claveAuth: string;
  autorizacionCodigo: string;
  bolAutorizacion: boolean;
  largo: string;
  permisos: SegMaePermiso;
  strNombreForma: string;
  auxreporte: number = 0;
  boldateAutoriza: boolean;

  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  rowStyleEC;
  rowStyleSaldo;
  defaultColDef;
  disablebodconfig = false
  disablebod: boolean = false;
  NVZCCANTO
  displayDialogDocumentos = false;
  // Seriales
  strNumFact: any;
  strFechaSer: any;
  CNCANRECTR:any
  columnDefsDettransfer = [
    { // 0
      headerName: 'Código', field: 'ART_CODIGO', cellEditor: 'cellPrueba', width: 250,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Descripción', field: 'ART_NOMBRE', cellEditor: 'cellPrueba', width: 200,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    { // 2
      headerName: 'Unidad', field: 'UNI_CODIGO', cellEditor: 'cellPrueba', width: 100,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 200
        }
      }
    },
    { // 3
      headerName: 'Recibido', field: 'DETTRANSFER_RECIBIDO', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' }, width: 100,
      editable: (params) => {
        return true;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tienecalculos: true,
          tamanocelda: 32,
          int: true,
        }
      }
    },
    { // 10
      headerName: 'Cantidad original', field: 'DETTRANSFER_CANTORIGINAL', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' }, width: 100,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: false,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 3,
          obligatorio: true,
          fecha: false,
          clave: true,
          tienecalculos: true
        }
      }
    }
    //CDPJ
  ];

  constructor(public enctransferService: InvenctransferrecibidoService, private init: NuevoComponentService,
    private busqService: InvbusquedaService, private datePipe: DatePipe,
    private messageService: MessageService, private errorService: ErroresBaseDatosService,
    private auditoriagral: AuditoriagralService, private confIniciales: ConfInicialesService,
    private confirmationService: ConfirmationService, private utilitariosService: UtilitariosService,
    private permisosService: PermisosService, public usuario: Usuario) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };

    this.defaultColDef = {
      editable: true,
      width: 100,
      objeto: 'dettransferrecib'
    };

    /*this.defaultColDefVarios = {
      editable: true,
      width: 100,
      objeto: 'trnvariostrf'
    };*/
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.largo = '-5800';
    this.index = 0;

    this.ListarConfiguracionesTransfer();

    this.displayAcciones = false;

    this.barraBotones2 = true;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonFactura = false;
    this.botonAnular = false;
    this.botonXML = false;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.botonAutorizar = true;
    this.groupCodProv = false;
    this.groupDatosPorNumAdic = true;

    this.enctransferService.invenctransferarray[this.indicador] = {
      ASI_NRO: ''
    };

    this.enctransferService.invdettransferarray[this.indicador] = [];
    const dec: any = await this.confIniciales.getDecimalesP('frmINV_ENCTRANSFER');
    const permiso = await this.permisosService.getListaPermisos('INV', '6', '852').toPromise();
    this.enctransferService.decdetcantidad = 2;

    if (dec !== null) {
      dec.map((decimales) => {
        if (decimales.NUMDEC_CAMPO === 'TOTALDET') {
          this.enctransferService.decTOTALDET = Number(decimales.NUMDEC_NUMDEC);
        } else if (decimales.NUMDEC_CAMPO === 'TOTAL') {
          this.enctransferService.decTOTAL = Number(decimales.NUMDEC_NUMDEC);
        } else if (decimales.NUMDEC_CAMPO === 'CANTIDAD') {
          this.enctransferService.decdetcantidad = Number(decimales.NUMDEC_NUMDEC);
        } else if (decimales.NUMDEC_CAMPO === 'COSTO') {
          this.enctransferService.decdetcosto = Number(decimales.NUMDEC_NUMDEC);
        }
      });
    }

    this.columnDefsDettransfer[3].cellEditorParams = {
      values: {
        mayusculas: false,
        numeros: true,
        alphabetic: false,
        saltoslinea: 1,
        newrow: false,
        numerodecimales: this.enctransferService.decdetcantidad,
        obligatorio: true,
        fecha: false,
        clave: false,
        tienecalculos: true,
        tamanocelda: 32,
        int: true,
      }
    }
    this.columnDefsDettransfer[4].cellEditorParams = {
      values: {
        mayusculas: false,
        numeros: true,
        alphabetic: false,
        saltoslinea: 1,
        newrow: false,
        numerodecimales: this.enctransferService.decdetcantidad,
        obligatorio: true,
        fecha: false,
        clave: false,
        tienecalculos: true,
        tamanocelda: 32,
        int: true,
      }
    }
    this.aggrid.refreshColumnDefsIndice(this.indicador, this.defaultColDef.objeto, this.columnDefsDettransfer);

    //this.permisosService.getListaPermisos('INV', '6', '852').subscribe((permiso) => {
    this.permisos = permiso[0];
    //});

  }
  async manejarSenales(valor) {
    if (valor !== 'Nuevo' && valor !== 'Cancelar'
      && valor !== 'Primero' && valor !== 'Anterior' && valor !== 'Siguiente' && valor !== 'Ultimo'
      && valor !== 'Buscar' && valor !== 'Imprimir' && valor !== 'AsientoVer' && valor !== 'Salir') {
      // Verifica el periodo contable
      const dia = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_FECHAEMISION.getDate();
      const mes = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_FECHAEMISION.getMonth();
      const anio = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_FECHAEMISION.getFullYear();

      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.messageService.add({
          key: 'enctransferrecib',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, fecha debe de estar dentro del período contable'
        });
        return;
      }
    }

    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;

    // if (valor === 'Nuevo') {
    //   if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
    //     // if (this.enctransferService.TNRBLBODO === 1 &&
    //     //   (this.boduser === null
    //     //     || this.boduser === undefined
    //     //     || this.boduser === '') && this.disablebodconfig === true) {
    //     //   this.messageService.add({
    //     //     key: 'enctransfer',
    //     //     severity: 'info',
    //     //     summary: 'Información',
    //     //     detail: 'Error, No tiene parametrizada una bodega, comuniquese con soporte '
    //     //   });
    //     //   return
    //     // }
    //     this.nuevo();
    //   }

    // }
    if (valor === 'Guardar') {
      if (this.control === 0) {
        this.control = 1
        this.guardarRegistro();
      }

    }
    // if (valor === 'Borrar') {
    //   this.eliminar();
    // }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
    if (valor === 'Primero') {
      //CDPJ
      // if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)
      // ) {
      console.log('5');
      this.seleccionarRegistro('P');
      //}
      //CDPJ
    }
    if (valor === 'Anterior') {
      //CDPJ
      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.seleccionarRegistro('A');
      //}
      //CDPJ
    }
    if (valor === 'Siguiente') {
      //CDPJ
      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.seleccionarRegistro('S');
      //}
      //CDPJ
    }
    if (valor === 'Ultimo') {
      //CDPJ
      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.seleccionarRegistro('U');
      //}
      //CDPJ
    }
    if (valor === 'Buscar') {
      //CDPJ
      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.buscar();
      //}
      //CDPJ
    }
    if (valor === 'Autorizar') {
      //CDPJ
      if (this.permisos.PERTODO === 0) {
        if (this.permisos.PERINSERCION === 0 && this.permisos.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción ni de actualización, Consulte con el Administrador del Sistema.'
          });
          return;
        }
        if (this.permisos.PERSELECCION === 1 && this.permisos.PERINSERCION === 0 && this.permisos.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario solo tiene permisos para consultar, Consulte con el Administrador del Sistema.'
          });
          return;
        }
      }
      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.autorizaTransferencia();
      //}
      //CDPJ
    }
    if (valor === 'Transferir') {
      //CDPJ
      if (this.permisos.PERTODO === 0) {
        if (this.permisos.PERINSERCION === 0 && this.permisos.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'enctransfer',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción ni de actualización, Consulte con el Administrador del Sistema.'
          });
          return;
        }
        if (this.permisos.PERSELECCION === 1 && this.permisos.PERINSERCION === 0 && this.permisos.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'enctransfer',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario solo tiene permisos para consultar, Consulte con el Administrador del Sistema.'
          });
          return;
        }
      }

      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.realizarTransferencia();
      //}
      //CDPJ
    }
    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Almacenardoc') {
      if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO !== '') {
        const usu = await this.confIniciales.obtenerPermisoUsuario(this.usuario.identificacion);
        if (usu[0].USU_ALMACENARDOC === 1 || usu[0].USU_VISUALIZARDOC === 1) {
          this.displayDialogDocumentos = true;
        } else {
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'info',
            summary: 'Información',
            detail: 'No tiene los permisos necesarios. Consulte con el Administrador del Sistema'
          });
        }

      }
    }
    if (valor === 'Salir') {
      //if (await this.ValidarSeriales(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)) {
      this.init.tabs.splice(this.init.tabindex, 1);
      //}

    }
  }

  realizarTransferencia() {
    let strEstado = '';

    // let dblTotalTransf = 0;
    // let dblTotalVarios = 0;

    /*dblTotalTransf = this.enctransferService.calcularCostoTotal();
    // dblTotalVarios = this.enctransferService.calcularTotalVarios();
    if (dblTotalVarios > 0) {
      if (dblTotalTransf !== dblTotalVarios) {
        this.messageService.add({
          key: 'enctransfer',
          severity: 'error',
          summary: 'Información',
          detail: 'El total varios no es igual al total de la transferencia'
        });
        return;
      }
    }*/
    if (this.botonGuardar === false) {
      this.messageService.add({
        key: 'enctransferrecib',
        severity: 'error',
        summary: 'Información',
        detail: 'Guarde la factura para realizar la transferencia'
      });
      return;
    }

    this.enctransferService.erRealTransfer(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO).subscribe(er => {
      if (er !== null) {
        if (er[0] !== undefined) {
          strEstado = er[0].TRANSFER_ESTADO;
        }
      }

      if (strEstado !== null) {
        if (strEstado !== 'A') {
          if (strEstado === 'T') {
            this.confirmationService.confirm({
              message: 'Está seguro de reversar la transferencia',
              header: 'Información',
              icon: 'pi pi-exclamation-triangle',
              key: 'confirmenctransferrecib',
              accept: () => {
                this.confirmationService.close();
                this.reversarTransferencia();
              },
              reject: () => {
                this.confirmationService.close();
              }
            });
            return;
          }
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'error',
            summary: 'Información',
            detail: 'Debe autorizar e ingresar el nombre de la persona que autorizó la transferencia y guarde'
          });
          return;
        } else {
          this.confirmationService.confirm({
            message: 'Está seguro de realizar la transferencia',
            header: 'Información',
            icon: 'pi pi-exclamation-triangle',
            key: 'confirmenctransferrecib',
            accept: () => {
              this.confirmationService.close();
              this.transferir();
            },
            reject: () => {
              this.confirmationService.close();
            }
          });
        }
      }
    });
  }

  async reversarTransferencia() {
    let strSentencia = 'delete from inv_trnkardex where com_codigo=' + '\'01\'';
    strSentencia = strSentencia + ' and trnart_numero=trim(' + '\'' +
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO + '\'' + ')';

    await this.enctransferService.reversarTransferencia(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO);
    this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO = 'AUTORIZADO';
    // Actualizar el estado de la transferencia
    await this.guardarRegistro();
    await this.actualizaEntregasReserva('P');
    this.botonAutorizar = true;
    // this.enctransferService.ejecutarConsulta(strSentencia).subscribe(data => {
    //   this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO = 'AUTORIZADO';
    //   // Actualizar el estado de la transferencia
    //   this.guardarRegistro();
    // });


  }

  async transferir() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;

    const strFechaTransferencia = this.datePipe.transform(this.enctransferService.invenctransferarray[
      this.indicador].TRANSFER_FECHATRANSFER, 'dd/MM/yyyy');
    const strHora = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORA;


    if (await this.verificarExistencia() === false) {
      return;
    }


    this.enctransferService.registroTrnKardex(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO,
      strFechaTransferencia + ' ' + strHora).subscribe(data => {
        // actualiza el estado
        this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO = 'TRANSFERIDO';
        this.botonAutorizar = false;
        // Actualizar el estado de la transferencia
        this.guardarRegistro();
        this.actualizaEntregasReserva('T');
        // Recalcula el costo promedio de los articulos insertados
        // if (this.intRecalculaCostoPromedio == 1) {
        const strFechaEmision = this.datePipe.transform(this.enctransferService.invenctransferarray[
          this.indicador].TRANSFER_FECHAEMISION, 'dd/MM/yyyy');
        this.enctransferService.recalculaCostoArtDoc('select art_codigo from inv_dettransfer' +
          ' where TRANSFER_NRO=' + '\'' + this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO +
          '\'', strFechaEmision);
        // }
      });
  }

  async verificarExistencia() {
    let intIndiceLista = 0;
    let item: InvDettransfer;
    let dblExistencia = 0;

    const strFechaTransferencia = this.datePipe.transform(this.enctransferService.invenctransferarray[
      this.indicador].TRANSFER_FECHATRANSFER, 'dd/MM/yyyy');
    const strHora = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORA;

    for (intIndiceLista = 0; intIndiceLista < this.enctransferService.invdettransferarray[this.indicador].length; intIndiceLista++) {
      item = this.enctransferService.invdettransferarray[this.indicador][intIndiceLista];
      if (item.ART_CODIGO !== '') {
        const data = await this.enctransferService.obtenerExistenciaBodega('FAC', item.ART_CODIGO,
          this.enctransferService.invenctransferarray[this.indicador].BOD_CODIGO, strFechaTransferencia, strHora);
        for (const rs of data) {
          dblExistencia = rs.EXIST;
        }
        if (dblExistencia < item.DETTRANSFER_CANTIDAD) {
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'error',
            summary: 'Información',
            detail: 'No hay la existencia necesaria del artículo ' + item.ART_CODIGO + ', ' +
              'la existecia actual es de: ' + dblExistencia
          });
          return false;
        }
      }
    }
    return true;
  }

  async actualizaEntregasReserva(estado) {
    for (const item of this.enctransferService.invdettransferarray[this.indicador]) {
      if (item.TRNRES_NUMERO !== '' && item.TRNRES_NUMERO !== null) {
        await this.enctransferService.actualizarEntregaReserva(item.TRNRES_NUMERO, Number(item.DETTRANSFER_CANTIDAD), estado);
      }
    }
  }

  ListarConfiguracionesTransfer() {

    this.enctransferService.ecListConfTransfer().subscribe(async data => {
      for (const rs of data) {

        if (rs.CFG_CODIGO === 'NVZCCANTO') {
          this.NVZCCANTO = Number(rs.CFG_VALOR1);
        }

      }
      if (this.NVZCCANTO === 1) {
        this.columnDefsDettransfer.splice(4, 1);
        this.columnDefsDettransfer.splice(4, 1);
        this.aggrid.refreshColumnDefs();
      }
    });

  }
  comprobarClave() {
    this.enctransferService.obtenerClave(this.autorizacionCodigo).subscribe((clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        this.accionesAutorizacion();
      } else if (clave !== this.claveAuth) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }
    });
  }
  selecciondettransfer(params) {

  }
  cambio(cambio) {
    if (cambio === true) {
      this.botonGuardar = false;
      this.botonRegresar = false;
      this.botonNuevo = true;
    }
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'txtComprobante': {
        element = document.getElementById('txtCodBodOrigen');
        break;
      }
      case 'txtCodBodOrigen': {
        //this.busquedaBodega(event.target.value, 'origen');
        break;
      }
      case 'txtCodBodDestino': {
        //this.busquedaBodega(event.target.value, 'destino');
        break;
      }
      case 'txtComentario': {
        // this.nuevodetalle();
        break;
      }
      case 'txtNombreAutoriza': {
        element = document.getElementById('txtReferencia');
        break;
      }
      case 'txtReferencia': {
        element = document.getElementById('txtCodTransportista');
        break;
      }
      case 'txtCodTransportista': {
        //this.busquedaTransportista(event.target.value);
        break;
      }
      case 'txtCodCliente': {
        // this.busquedacliente(event.target.value);
        break;
      }
    }


    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  async busquedacliente(parametro) {
    // if (parametro === null) {
    //   parametro = '';
    // }
    // this.opcionbusqueda = 'cliente';
    // this.types = [
    //   { label: 'Código', value: 'CLI_CODIGO' },
    //   { label: 'Nombre', value: 'CLI_NOMBRE' },
    //   { label: 'RucIde', value: 'CLI_RUCIDE' },
    //   { label: 'Zona', value: 'CLI_ZONA' },
    //   { label: 'Grupo', value: 'GRU_CODIGO' },
    //   { label: 'Contacto', value: 'CLI_CONTACTO' },
    //   { label: 'Placa', value: 'CLI_PLACA' },
    //   { label: 'NombreC', value: 'CLI_NOMBREC' },
    // ];
    // this.busquedacampos = [parametro, '', '', '', '', '', '', '', ''];
    // this.tabla = 'VEN_MAECLIENTE';
    // this.where = '';

    // if (parametro !== '' && parametro !== undefined && parametro !== null) {
    //   const eR = await this.enctransferService.erpBusquedaCliente(this.tabla, this.types[0].value, parametro);
    //   if (eR !== null) {
    //     if (eR[0] !== undefined) {
    //       this.manejarSeleccion(eR[0]);
    //       return;
    //     }
    //   }
    // }

    // this.busqService.busquedaVenMaeCliente3(parametro).subscribe((datos: any[]) => {
    //   this.arregloCons = datos;
    //   this.displayDialogBusquedaFast = true;
    // });

  }
  buscar() {
    this.opcionbusqueda = 'transferencia';
    this.types = [
      { label: 'Código', value: 'TRANSFER_NRO' },
      { label: 'Fec. Emisión', value: 'TRANSFER_FECHAEMISION' },
      { label: 'Fec. Transfer', value: 'TRANSFER_FECHATRANSFER' },
      { label: 'Bodega', value: 'BOD_CODIGO' },
      { label: 'Estado', value: 'TRANSFER_ESTADO' },
      { label: 'Cliente', value: 'CLI_CODIGO' },
      { label: 'Persona', value: 'TRANSFER_PERSONAAUTORIZA' },
      { label: 'Fec. Autoriza', value: 'TRANSFER_FECHAAUTORIZA' },
      { label: 'Comentario', value: 'TRANSFER_COMENTARIO' }
    ];


    this.busquedacampos = ['', '', '', '', '', '', '', '', ''];
    this.consulta = '';
    this.tabla = 'INV_ENCTRANSFER';
    this.where = 'transfer_estado in (\'P\',\'A\')';


    this.busqService.busquedaInvEncTransfer2().subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.arregloCons.map((registro) => {
        if (registro.TRANSFER_FECHAEMISION !== null) {
          registro.TRANSFER_FECHAEMISION = this.datePipe.transform(registro.TRANSFER_FECHAEMISION, 'dd/MM/yyyy');
        } else {
          registro.TRANSFER_FECHAEMISION = '';
        }
        if (registro.TRANSFER_FECHATRANSFER !== null) {
          registro.TRANSFER_FECHATRANSFER = this.datePipe.transform(registro.TRANSFER_FECHATRANSFER, 'dd/MM/yyyy');
        } else {
          registro.TRANSFER_FECHATRANSFER = '';
        }
        if (registro.TRANSFER_FECHAAUTORIZA !== null) {
          registro.TRANSFER_FECHAAUTORIZA = this.datePipe.transform(registro.TRANSFER_FECHAAUTORIZA, 'dd/MM/yyyy');
        } else {
          registro.TRANSFER_FECHAAUTORIZA = '';
        }
      });
      this.displayDialogBusquedaFast = true;
    });
  }
  async cancelar() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    const numero = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO;
    if (numero === null || numero === undefined || numero === '') {
      //await this.limpiarDatos();
    } else {
      await this.encontrarTransferencia(numero);
    }
  }
  seleccionarRegistro(strTipo) {
    this.irAregistro(strTipo);
  }

  irAregistro(strTipo) {
    if (strTipo === 'P') {
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'A' || strTipo === 'S') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'U') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = false;
      this.botonUltimo = false;
    }

    let numero = '';

    if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO !== undefined) {
      numero = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO;
    }

    this.enctransferService.seleccionarRegistro(strTipo, numero,
      'com_codigo=\'01\' and transfer_estado in (\'P\',\'A\')').subscribe((datos: any[]) => {
        if (datos !== null) {
          //this.limpiarDatos();
          this.encontrarTransferencia(datos[0].TRANSFER_NRO);
          this.botonNuevo = false;
          this.botonGuardar = true;
          this.botonBorrar = false;
          this.botonRegresar = true;
        }
      }, error1 => {
        const error = this.errorService.generarMensajeError(error1.error.substr(0, 9));
        this.messageService.add({
          key: 'enctransfer',
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }
  autorizaTransferencia() {
    this.claveAuth = '';
    this.autorizacionCodigo = 'AUTTRF';
    this.displayDialogAutorizacion = true;
  }
  accionesAutorizacion() {
    if (this.autorizacionCodigo === 'AUTTRF') {
      const fechaActual = new Date();
      const hora = new Date()
      this.boldateAutoriza = true;
      this.botonesmodificar();
      this.nombreEstado('A');
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_FECHAAUTORIZA = fechaActual;
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORAAUTORIZA = this.datePipe.transform(hora, 'HH:mm')

      document.getElementById('txtNombreAutoriza').focus();
      this.displayDialogAutorizacion = false;
    }
  }
  botonesmodificar() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
  }
  onHideAutorizacion() {
    if (this.bolAutorizacion === false) {
      if (this.autorizacionCodigo === 'AUTTRF') {
        this.messageService.add({
          key: 'enctransferrecib',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar correctamente'
            + ' la clave.'
        });
      }
    }
  }
  async guardarRegistro() {
    if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO.length === 0) {
      if (this.permisos.PERTODO === 0) {
        if (this.permisos.PERINSERCION === 0) {
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, Consulte con el Administrador del Sistema.'
          });
          this.control = 0;//CDPJ
          return;
        }
      }
    } else {
      if (this.permisos.PERTODO === 0) {
        if (this.permisos.PERACTUALIZACION === 0) {
          this.messageService.add({
            key: 'enctransferrecib',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, Consulte con el Administrador del Sistema.'
          });
          this.control = 0;//CDPJ
          return;
        }
      }
    }
    const strFechaEmision = this.datePipe.transform(this.enctransferService.invenctransferarray[
      this.indicador].TRANSFER_FECHAEMISION, 'dd/MM/yyyy');
    const strFechaAutorizacion = this.datePipe.transform(this.enctransferService.invenctransferarray[
      this.indicador].TRANSFER_FECHAAUTORIZA, 'dd/MM/yyyy');
    const strFechaTransferencia = this.datePipe.transform(this.enctransferService.invenctransferarray[
      this.indicador].TRANSFER_FECHATRANSFER, 'dd/MM/yyyy');

    let strHora;
    //GSRF
    if (this.enctransferService.horacam === this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORA) {
      strHora = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORA;
      console.log('AQUIIII11111', strHora);
    } else {
      strHora = this.datePipe.transform(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORA, 'HH:mm');
      console.log('AQUIIII2222', strHora);
    }
    //GSRF
    if (this.enctransferService.invenctransferarray[this.indicador].BOD_CODIGO === '' ||
      this.enctransferService.invenctransferarray[this.indicador].BOD_DESTINO === '') {
      this.messageService.add({
        key: 'enctransferrecib',
        severity: 'error',
        summary: 'Información',
        detail: 'Ingrese la Bodega Origen y la Bodega Destino'
      });
      this.control = 0;//CDPJ
      return;
    }

    if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONAAUTORIZA === null) {
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONAAUTORIZA = '';
    }
    if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONARECIBE === null) {
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONARECIBE = '';
    }

    if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONARECIBE === '' &&
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'AUTORIZADO') {
      this.messageService.add({
        key: 'enctransferrecib',
        severity: 'error',
        summary: 'Información',
        detail: 'Ingrese el Nombre de la persona que autoriza la transferencia'
      });
      this.control = 0;//CDPJ
      return;
    }
    if (await this.validadetalle() === true) {
      this.control = 0;//CDPJ
      return;
    }
    if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO.length === 0) {
      // // if (this.permisos.PERTODO === 0) {
      // // } else if (this.permisos.PERINSERCION === 0) {
      // //   this.messageService.add({
      // //     key: 'enctransfer',
      // //     severity: 'error',
      // //     summary: 'Información',
      // //     detail: 'El usuario no tiene permisos de inserción, Consulte con el Administrador del Sistema.'
      // //   });
      // //   return;
      // // }
      // const item: InvEnctransfer = {};
      // item.COM_CODIGO = this.enctransferService.invenctransferarray[this.indicador].COM_CODIGO;
      // item.TRANSFER_FECHAEMISION = strFechaEmision;
      // item.TRANSFER_FECHAAUTORIZA = strFechaAutorizacion;
      // item.TRANSFER_FECHATRANSFER = strFechaTransferencia;
      // item.BOD_CODIGO = this.enctransferService.invenctransferarray[this.indicador].BOD_CODIGO;
      // item.TRANSFER_COMENTARIO = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_COMENTARIO;
      // item.TRANSFER_ESTADO = '';
      // if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'PENDIENTE') {
      //   item.TRANSFER_ESTADO = 'P';
      // }
      // if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'AUTORIZADO') {
      //   item.TRANSFER_ESTADO = 'A';
      // }
      // if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'TRANSFERIDO') {
      //   item.TRANSFER_ESTADO = 'T';
      // }
      // item.TRANSFER_COMPROBANTE = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_COMPROBANTE;
      // item.TRANSFER_PERSONAAUTORIZA = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONAAUTORIZA;
      // if (this.chkguiaremision === true) {
      //   item.TRANSFER_TIPO = 'G';
      // } else {
      //   item.TRANSFER_TIPO = 'N';
      // }
      // item.TRANSPORT_CODIGO = this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_CODIGO;
      // item.TRANSFER_REFER = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_REFER;
      // item.TRANSFER_FLAG = 0;
      // item.MUESTRARIO = this.enctransferService.invenctransferarray[this.indicador].MUESTRARIO;
      // item.CLI_CODIGO = this.enctransferService.invenctransferarray[this.indicador].CLI_CODIGO;
      // item.TRANSFER_REFERENCIA = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_REFERENCIA;
      // item.PRO_CODIGO = this.enctransferService.invenctransferarray[this.indicador].PRO_CODIGO;
      // item.PRO_NOMBRE = this.enctransferService.invenctransferarray[this.indicador].PRO_NOMBRE;
      // item.TRANSFER_HORA = strHora;

      // const data = await this.enctransferService.insertarEnctransferProm(item).catch(e => {
      //   this.control = 0;//CDPJ
      //   return;
      // });
      // for (const rs of data) {
      //   this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO = rs.TRANSFER_NRO;
      //   if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_COMPROBANTE === '') {
      //     this.enctransferService.invenctransferarray[this.indicador].TRANSFER_COMPROBANTE = rs.TRANSFER_NRO;
      //   }
      // }

      // this.auditoriagral.registrarAuditoria('INV_ENCTRANSFER',
      //   this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO, 'I',
      //   '', '01', '', '', '', '').subscribe();
      // await this.GuardarDetalle();
      // if (item.TRANSFER_ESTADO === 'T') {
      //   await this.transferir();
      //   document.getElementById('contorno').style.pointerEvents = 'none';
      // }
      // //CDPJ
      // this.disablebod = true;
      // this.disablebodconfig = true;
      // //CDPJ
      // this.botonNuevo = false;
      // this.botonGuardar = true;
      // this.botonBorrar = false;
      // this.botonRegresar = true;
      // this.encontrarTransferencia(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO);
    } else { // Fin si  es nuevo registro
      // Actualiza
      if (this.permisos.PERTODO === 0) {
      } else if (this.permisos.PERACTUALIZACION === 0) {
        this.messageService.add({
          key: 'enctransferrecib',
          severity: 'error',
          summary: 'Información',
          detail: 'El usuario no tiene permisos de actualización, Consulte con el Administrador del Sistema.'
        });
        this.control = 0;//CDPJ
        return;
      }
      const item: InvEnctransfer = {};
      item.TRANSFER_NRO = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO;
      item.COM_CODIGO = this.enctransferService.invenctransferarray[this.indicador].COM_CODIGO;
      item.TRANSFER_FECHAEMISION = strFechaEmision;
      item.TRANSFER_FECHAAUTORIZA = strFechaAutorizacion;
      item.TRANSFER_FECHATRANSFER = strFechaTransferencia;

      item.BOD_CODIGO = this.enctransferService.invenctransferarray[this.indicador].BOD_CODIGO;
      item.TRANSFER_COMENTARIO = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_COMENTARIO;
      if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'PENDIENTE') {
        item.TRANSFER_ESTADO = 'P';
      }
      if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'AUTORIZADO') {
        item.TRANSFER_ESTADO = 'A';
      }
      if (this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO === 'TRANSFERIDO') {
        item.TRANSFER_ESTADO = 'T';
      }
      item.TRANSFER_COMPROBANTE = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_COMPROBANTE;
      item.TRANSFER_PERSONAAUTORIZA = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONAAUTORIZA;
      item.TRANSFER_PERSONARECIBE = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_PERSONARECIBE

      if (this.chkguiaremision === true) {
        item.TRANSFER_TIPO = 'G';
      } else {
        item.TRANSFER_TIPO = 'N';
      }
      item.TRANSPORT_CODIGO = this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_CODIGO;
      item.MUESTRARIO = this.enctransferService.invenctransferarray[this.indicador].MUESTRARIO;
      item.CLI_CODIGO = this.enctransferService.invenctransferarray[this.indicador].CLI_CODIGO;
      item.TRANSFER_REFERENCIA = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_REFERENCIA;
      item.PRO_CODIGO = this.enctransferService.invenctransferarray[this.indicador].PRO_CODIGO;
      item.PRO_NOMBRE = this.enctransferService.invenctransferarray[this.indicador].PRO_NOMBRE;
      item.TRANSFER_HORA = strHora;
      item.TRANSFER_HORAAUTORIZA = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_HORAAUTORIZA
      await this.enctransferService.actualizarEnctransferProm(item);
      this.auditoriagral.registrarAuditoria('INV_ENCTRANSFERRECIB',
        this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO, 'A',
        '', '01', '', '', '', '').subscribe();
      await this.GuardarDetalle();
      //CDPJ
      this.disablebod = true;
      this.disablebodconfig = true;
      //CDPJ
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.control = 0;//CDPJ
      this.encontrarTransferencia(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO);
      /*this.enctransferService.actualizarEnctransfer(item).subscribe(() => {
        this.auditoriagral.registrarAuditoria('INV_ENCTRANSFER',
          this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO, 'A',
          '', '01', '', '', '', '').subscribe();
        this.GuardarDetalle();
        setTimeout(() => {
          this.botonNuevo = false;
          this.botonGuardar = true;
          this.botonBorrar = false;
          this.botonRegresar = true;
          this.encontrarTransferencia(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO);
        }, 200);
      }); */
    } // fin actualizacion

  }
  async validadetalle() {
    let bool = false
    let intIndiceLista
    let item: InvDettransfer = {};
    for (intIndiceLista = 0; intIndiceLista < this.enctransferService.invdettransferarray[this.indicador].length; intIndiceLista++) {
      item = this.enctransferService.invdettransferarray[this.indicador][intIndiceLista];
      if (item.BOD_CODIGO !== this.enctransferService.invenctransferarray[this.indicador].BOD_DESTINO) {
        this.messageService.add({
          key: 'enctransferrecib',
          severity: 'error',
          summary: 'Insertar Detalle Transferencia',
          detail: 'La bodega del artículo ' + item.ART_CODIGO + ' No es igual a la bodega de destino del encabezado'
        });
        bool = true
        return bool
      }
      if (isNullOrUndefined(item.DETTRANSFER_RECIBIDO) === true || item.DETTRANSFER_RECIBIDO === '') {
        this.messageService.add({
          key: 'enctransferrecib',
          severity: 'error',
          summary: 'Insertar Detalle Transferencia',
          detail: 'la cantidad recibida no puede estar vacía'
        });
        bool = true
        return bool
      }
    }
    return bool
  }
  async GuardarDetalle() {
    let intIndiceLista = 0;
    let item: InvDettransfer = {};
    for (intIndiceLista = 0; intIndiceLista < this.enctransferService.invdettransferarray[this.indicador].length; intIndiceLista++) {
      item = this.enctransferService.invdettransferarray[this.indicador][intIndiceLista];
      if (item.ART_CODIGO === '') {
        // lstInvDetTransfer.remove(intIndiceLista);
        this.enctransferService.invdettransferarray[this.indicador].splice(intIndiceLista, 1);
      }
    }

    intIndiceLista = 0;
    for (intIndiceLista = 0; intIndiceLista < this.enctransferService.invdettransferarray[this.indicador].length; intIndiceLista++) {
      item = this.enctransferService.invdettransferarray[this.indicador][intIndiceLista];
      if (item.ART_CODIGO !== '') {
        if (item.DETTRANSFER_LINEA === 0) {
          // const itemdet: InvDettransfer = {};
          // itemdet.TRANSFER_NRO = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO;
          // itemdet.COM_CODIGO = '01';
          // itemdet.ART_CODIGO = item.ART_CODIGO;
          // itemdet.BOD_CODIGO = item.BOD_CODIGO;
          // itemdet.DETTRANSFER_CANTIDAD = Number(item.DETTRANSFER_CANTIDAD);
          // itemdet.DETTRANSFER_COSTOTOTAL = Number(item.DETTRANSFER_COSTOTOTAL);
          // itemdet.UNI_CODIGO = item.UNI_CODIGO;
          // itemdet.DETTRANSFER_FLAG = 0;
          // itemdet.DETTRANSFER_COSTOUNIT = Number(item.DETTRANSFER_COSTOUNIT);
          // itemdet.DETTRANSFER_REFERENCIA = item.DETTRANSFER_REFERENCIA;
          // itemdet.TRNRES_NUMERO = item.TRNRES_NUMERO;
          // try {
          //   await this.enctransferService.insertarDetTransfer(itemdet);
          //   this.auditoriagral.registrarAuditoria('INV_DETTRANSFER',
          //     itemdet.TRANSFER_NRO + '/' + item.ART_CODIGO, 'I',
          //     '', '01', '', '', '', '').subscribe();
          //   if (itemdet.TRNRES_NUMERO !== '') {
          //     await this.enctransferService.cambiarEstadoReserva(itemdet.TRNRES_NUMERO, 'P');
          //   }
          // } catch (error1) {
          //   let mensaje: string;
          //   mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
          //   this.messageService.add({
          //     key: 'enctransfer',
          //     severity: 'error',
          //     summary: 'Insertar Detalle Transferencia',
          //     detail: mensaje
          //   });
          //   this.disablebod = false;//CDPJ
          //   if (this.enctransferService.TNRBLBODO === 0) {
          //     this.disablebodconfig = false
          //   }
          //   this.control = 0;//CDPJ
          // }
        } else { // Fin si inserta un nuevo registro
          const itemdet: InvDettransfer = {};
          itemdet.TRANSFER_NRO = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO;
          itemdet.COM_CODIGO = '01';
          itemdet.ART_CODIGO = item.ART_CODIGO;
          itemdet.BOD_CODIGO = item.BOD_CODIGO;
          itemdet.DETTRANSFER_CANTIDAD = Number(item.DETTRANSFER_CANTIDAD);
          itemdet.DETTRANSFER_COSTOTOTAL = Number(item.DETTRANSFER_COSTOTOTAL);
          itemdet.UNI_CODIGO = item.UNI_CODIGO;
          itemdet.DETTRANSFER_COSTOUNIT = Number(item.DETTRANSFER_COSTOUNIT);
          itemdet.DETTRANSFER_LINEA = item.DETTRANSFER_LINEA;
          itemdet.DETTRANSFER_REFERENCIA = item.DETTRANSFER_REFERENCIA;
          itemdet.DETTRANSFER_RECIBIDO = Number(item.DETTRANSFER_RECIBIDO)
          try {
            await this.enctransferService.actualizarDetTransfer(item, this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO);
            this.auditoriagral.registrarAuditoria('INV_DETTRANSFERRECIB',
              itemdet.TRANSFER_NRO + '/' + item.ART_CODIGO, 'A',
              '', '01', '', '', '', '').subscribe();

          } catch (error1) {
            let mensaje: string;
            mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
            this.messageService.add({
              key: 'enctransferrecib',
              severity: 'error',
              summary: 'Insertar Detalle Transferencia',
              detail: mensaje
            });
            this.disablebod = false;//CDPJ
            if (this.enctransferService.TNRBLBODO === 0) {
              this.disablebodconfig = false
            }
            this.control = 0;//CDPJ
          }
        } // Fin actualización
      } // Fin si no es un valor en blanco
    }
  }
  async encontrarTransferencia(transfernumero) {
    this.enctransferService.getEnctransfer(transfernumero).subscribe(data => {
      for (const rs of data) {
        const hora = new Date()
        this.enctransferService.horacam = rs.TRANSFER_HORA//GSRF
        rs.TRANSFER_FECHAEMISION = new Date(rs.TRANSFER_FECHAEMISION);
        rs.TRANSFER_FECHAAUTORIZA = new Date(rs.TRANSFER_FECHAAUTORIZA);
        rs.TRANSFER_FECHATRANSFER = new Date(rs.TRANSFER_FECHATRANSFER);
        rs.TRANSFER_HORAAUTORIZA = isNullOrUndefined(rs.TRANSFER_HORAAUTORIZA) === true || rs.TRANSFER_HORAAUTORIZA === '' ? this.datePipe.transform(hora, 'HH:mm') : rs.TRANSFER_HORAAUTORIZA;
        rs.MUESTRARIO = rs.TRANSFER_REFERENCIA;
        this.enctransferService.invenctransferarray[this.indicador] = rs;
        this.control = 0;//CDPJ
        this.nombreEstado(rs.TRANSFER_ESTADO);
        switch (rs.TRANSFER_ESTADO) {
          case 'P':
            document.getElementById('contorno').style.pointerEvents = 'all';
            this.botonXML = false;
            break;
          case 'T':
            document.getElementById('contorno').style.pointerEvents = 'none';
            this.botonNuevo = false;
            this.botonGuardar = true;
            this.botonBorrar = true;
            this.botonAutorizar = false;
            break;
          case 'A':
            document.getElementById('contorno').style.pointerEvents = 'none';
            this.boldateAutoriza = true;
            this.botonXML = true;
            break;
          default:
            break;
        }
      }
      this.enctransferService.getDettransfer(transfernumero).subscribe(datadet => {
        //CDPJ
        console.log(datadet)
        if (datadet.length === 0) {
          this.disablebod = false;
          if (this.enctransferService.TNRBLBODO === 0) {
            this.disablebodconfig = false
          }
        } else {
          this.disablebodconfig = true
          this.disablebod = true;
        }
        //CDPJ
        this.enctransferService.invdettransferarray[this.indicador] = datadet;
        for (const rsdet of this.enctransferService.invdettransferarray[this.indicador]) {
          rsdet.CLAVE = rsdet.DETTRANSFER_LINEA;
          rsdet.DETTRANSFER_COSTOUNIT = Number(rsdet.DETTRANSFER_COSTOUNIT).toFixed(this.enctransferService.decdetcosto);
          rsdet.DETTRANSFER_RECIBIDO = Number(rsdet.DETTRANSFER_RECIBIDO).toFixed(this.enctransferService.decdetcantidad);
          rsdet.DETTRANSFER_CANTORIGINAL = Number(rsdet.DETTRANSFER_CANTORIGINAL).toFixed(this.enctransferService.decdetcantidad);
        }
        for (const rsdet of datadet) {
          this.enctransferService.invenctransferarray[this.indicador].BOD_DESTINO = rsdet.BOD_CODIGO;
        }
        this.enctransferService.erFindBodDestino(this.enctransferService.invenctransferarray[this.indicador].BOD_DESTINO).subscribe(er => {
          if (er !== null) {
            if (er[0] !== undefined) {
              this.enctransferService.invenctransferarray[this.indicador].BOD_DESTINONOMBRE = er[0].BOD_NOMBRE;
            }
          }
        });
        //this.enctransferService.calcularCostoTotal();

        /*this.enctransferService.getTrnvariostrf(transfernumero).subscribe(datavar => {
          this.enctransferService.invtrnvariostrfarray[this.indicador] = datavar;
        });*/
      });
    });
  }
  nombreEstado(strEstado) {
    let strRefNombreC = '';

    this.enctransferService.erNombreEstado(strEstado).subscribe(er => {
      if (er !== null) {
        if (er[0] !== undefined) {
          strRefNombreC = er[0].REF_NOMBREC;
        }
      }
      if (strRefNombreC == null) {
        strRefNombreC = 'PENDIENTE';
      }
      this.enctransferService.invenctransferarray[this.indicador].TRANSFER_ESTADO = strRefNombreC;
    });

  }
  busquedaBodega(parametro, opcionbusqueda) {

  }
  async manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'transferencia') {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      //await this.limpiarDatos();
      await this.encontrarTransferencia(opcion.TRANSFER_NRO);
    }
    if (this.opcionbusqueda === 'transportista') {
      this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_CODIGO = opcion.TRANSPORT_CODIGO;
      this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_NOMBRE = opcion.TRANSPORT_NOMBRE;
      this.enctransferService.erFindCodigoTransportistas(this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_CODIGO).subscribe(er => {
        if (er !== null) {
          if (er[0] !== undefined) {
            this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_AUTO = er[0].TRANSPORT_AUTO;
          }
        }
      });
      this.enctransferService.erFindPlacaTransportistas(this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_CODIGO).subscribe(er => {
        if (er !== null) {
          if (er[0] !== undefined) {
            this.enctransferService.invenctransferarray[this.indicador].TRANSPORT_PLACA = er[0].TRANSPORT_PLACA;
          }
        }
      });
      document.getElementById('txtComprobante').focus();
    }
    this.salirDialog();
  }
  salirDialog() {
    this.displayDialogBusqueda = false;
    this.displayDialogBusquedaFast = false;
    this.displayDialogAutorizacion = false;
    this.displayDialogSeriales = false;
    this.displayAcciones = false;
  }
  busquedaTransportista(parametro) {
    if (parametro === undefined) {
      parametro = '';
    }

    this.opcionbusqueda = 'transportista';
    this.types = [
      { label: 'Código', value: 'TRANSPORT_CODIGO' },
      { label: 'Nombre', value: 'TRANSPORT_NOMBRE' },
      { label: 'Ruc', value: 'TRANSPORT_RUC' },
      { label: 'Teléfono1', value: 'TRANSPORT_TELEFONO1' },
      { label: 'Teléfono2', value: 'TRANSPORT_TELEFONO2' },
      { label: 'Dirección', value: 'TRANSPORT_DIRECCION' }
    ];
    this.busquedacampos = [parametro, '', '', '', '', ''];
    this.consulta = '';
    this.tabla = 'VEN_MAETRANSPORT';
    this.where = '';

    this.enctransferService.erFindTransportistas(this.tabla, this.types[0].value, parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busqService.busquedaVenMaeTranport1(parametro).subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.busqService.busquedaVenMaeTranport1(parametro).subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.displayDialogBusquedaFast = true;
        });
      }
    });
  }
  async habilitartransfer() {
    try {
      await this.enctransferService.actualizarpendiente(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)
      this.encontrarTransferencia(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO)
      this.closeSidebar();

    } catch (error) {

    }

  }
  acciones() {
    this.displayAcciones = !this.displayAcciones;
    const elemento = document.getElementsByClassName('layout-config');
    if (this.displayAcciones === true) {
      for (let i = 1; i <= elemento.length; i++) {
        elemento[i - 1].className += ' layout-config-active';
      }
    } else if (this.displayAcciones === false) {
      for (let i = 1; i <= elemento.length; i++) {
        elemento[i - 1].className = 'layout-config';
      }
    }
  }
  closeSidebar() {
    this.displayAcciones = false;
    const elemento = document.getElementsByClassName('layout-config');
    for (let i = 1; i <= elemento.length; i++) {
      elemento[i - 1].className = 'layout-config';
    }
  }
  verseriales() {
    this.strNumFact = this.enctransferService.invenctransferarray[this.indicador].TRANSFER_NRO;
    this.strFechaSer = this.datePipe.transform(this.enctransferService.invenctransferarray[this.indicador].TRANSFER_FECHAEMISION, 'dd/MM/yyyy');
    this.displayDialogSeriales = true;
    this.CNCANRECTR=1
    this.closeSidebar();
  }
  cerrarSeriales() {
    this.displayDialogSeriales = false;
  }
}
